const employeeHashId = () => {
  const pathTokens = window.location.pathname.split("/");
  const idTokenIndex = pathTokens.indexOf("company-admin");
  const idToken = idTokenIndex != -1 ? pathTokens[idTokenIndex + 2] : null;
  return idToken;
};
export default employeeHashId;
